import { Provider } from 'react-redux';

export const ProviderWrapper = ({ children, store }) => <Provider store={store}>{children}</Provider>;
